import component from './tnt.component';
import success from './success/success.controller';

export default angular.module('mpdx.tools.import.tnt', [component, success]).name;
